import { RegionManager } from '@scenario/models/region-manager.model';
import { RegionManagerEntity } from './region-manager.entity';
export class RegionManagerMapper {
  mapToModel(entity: RegionManagerEntity): RegionManager {
    const model: RegionManager = {
      id: entity.id,
      source: entity.sourceId === undefined ? undefined : { id: entity.sourceId, name: '', category: '' },
      marketArea: entity.marketAreaId === undefined ? undefined : { id: entity.marketAreaId, name: '' },
      firstName: entity.firstName,
      lastName: entity.lastName,
      email: entity.email,
    };
    this.addOptionalModelFields(model, entity);
    return model;
  }
  mapArrayToModel(entities: RegionManagerEntity[]): RegionManager[] {
    return entities.map(entity => this.mapToModel(entity));
  }
  mapToEntity(regionManager: RegionManager): RegionManagerEntity {
    const entity: RegionManagerEntity = {
      id: regionManager.id,
      sourceId: regionManager.source?.id,
      marketAreaId: regionManager.marketArea?.id,
      firstName: regionManager.firstName,
      lastName: regionManager.lastName,
      email: regionManager.email,
    };
    this.addOptionalEntityFields(entity, regionManager);
    return entity;
  }
  private addOptionalModelFields(model: RegionManager, entity: RegionManagerEntity): void {
    if (entity.userId !== undefined) model.userId = entity.userId;
    if (entity.startDate !== undefined) model.startDate = entity.startDate;
    if (entity.endDate !== undefined) model.endDate = entity.endDate;
    if (entity.addedByEmail !== undefined) model.addedByEmail = entity.addedByEmail;
    if (entity.removedByEmail !== undefined) model.removedByEmail = entity.removedByEmail;
  }
  private addOptionalEntityFields(entity: RegionManagerEntity, model: RegionManager): void {
    if (model.userId !== undefined) entity.userId = model.userId;
    if (model.startDate !== undefined) entity.startDate = model.startDate;
    if (model.endDate !== undefined) entity.endDate = model.endDate;
    if (model.addedByEmail !== undefined) entity.addedByEmail = model.addedByEmail;
    if (model.removedByEmail !== undefined) entity.removedByEmail = model.removedByEmail;
  }
}
